import { useTracker } from '@common/log-manager';
import { getUrl } from '@domains/pdp-common';

export const useInquiryUBL = () => {
  const tracker = useTracker();
  const subtabInquiryTopClickUBL = () => {
    tracker.sendImmediately({
      category: 'click',
      navigation: 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_section: 'subtab_inquiry_top',
      object_type: 'button',
      object_id: 'app_download',
    });
  };

  const subtabInquiryBottomClickUBL = () => {
    tracker.sendImmediately({
      category: 'click',
      navigation: 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_section: 'subtab_inquiry_bottom',
      object_type: 'button',
      object_id: 'app_download',
    });
  };

  return { subtabInquiryTopClickUBL, subtabInquiryBottomClickUBL };
};
